<template>
	<MglMap
		:class="fullscreen ? 'mapbox-map-fullscreen' : 'mapbox-map'"
		:accessToken="accessToken"
		:mapStyle.sync="mapStyle"
		@load="onMapLoaded"
	>
		<MglMarker
			v-for="(marker, index) in markers"
			:key="index"
			:coordinates="!customMarkers ? marker : marker.loc"
			:color="!customMarkers || !Object.hasOwn(marker, 'color') ? 'red' : marker.color"
			:draggable="moveMarker"
			@drag="moveMarker ? showPopUp = false : ()=>{}"
			@dragend="moveMarker ? moveMaker($event) : ()=>{}"
		>
			<MglPopup :closeButton="false" :showed="showPopUp" :offset="10">
				<div class="markerText">
					{{ !customMarkers ? message : marker.message }}
				</div>
			</MglPopup>
		</MglMarker>
		<MglGeojsonLayer
			v-if="coverageGeometry"
			sourceId="coverage"
			:source="{
				type: 'geojson',
				data: coverageGeometry,
			}"
			layerId="myLayer"
			:layer="{
				type: 'fill',
				paint: {
					'fill-color': '#8a2be2',
					'fill-opacity': 0.4,
				},
			}"
		/>
	</MglMap>
</template>

<script>
import {
	MglMap,
	MglNavigationControl,
	MglGeolocateControl,
	MglGeojsonLayer,
	MglPopup,
	MglMarker,
} from 'vue-mapbox';

export default {
	components: {
		MglMap,
		MglPopup,
		MglMarker,
		MglGeojsonLayer,
	},
	props: {
		geoLatLng: {
			type: Array,
			default: () => [],
		},
		coverageGeometry: {
			type: Object,
			default: () => {},
		},
		fullscreen: {
			type: Boolean,
			default: false,
		},
		customMarkers: {
			type: Boolean,
			default: false,
		},
		moveMarker: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			accessToken:
				'pk.eyJ1IjoiY2F6emhkIiwiYSI6ImNsYXpzN2dxeTBhbmIzcWxveWJzOWdhZWkifQ.xO1cR4vV6WH-UxHwz9xmiQ',
			mapStyle: 'mapbox://styles/mapbox/streets-v11',
			showPopUp: false,
			message: 'Arrastrame si es necesario para precisar',
			actions: null,
			lastZoom: null,
		};
	},

	created() {
		this.mapbox = null;
	},
	methods: {
		isArray() {
			return this.geoLatLng.some((item) => Array.isArray(item));
		},
		getPoints() {
			return !this.customMarkers ? this.markers : this.markers.map((item) => item.loc);
		},
		getMaxMin() {
			const points = this.getPoints();

			// get the max and min longitude and latitude
			const maxLng = Math.max.apply(null, points.map((item) => item[0]));
			const minLng = Math.min.apply(null, points.map((item) => item[0]));
			const maxLat = Math.max.apply(null, points.map((item) => item[1]));
			const minLat = Math.min.apply(null, points.map((item) => item[1]));

			return {
				maxLng,
				minLng,
				maxLat,
				minLat,
			};
		},
		getCenterAndSpan() {
			const { maxLng, minLng, maxLat, minLat } = this.getMaxMin();

			// calculate the center and the span
			const centerLng = (maxLng + minLng) / 2;
			const centerLat = (maxLat + minLat) / 2;
			const spanLng = maxLng - minLng;
			const spanLat = maxLat - minLat;

			return {
				centerLng,
				centerLat,
				spanLng,
				spanLat,
			};
		},
		getMiddlePoint() {
			const defaultCoords = [-3.7037902, 40.4167754];
			const { centerLng, centerLat } = this.getCenterAndSpan();
			return !centerLng && !centerLat ? defaultCoords : [centerLng, centerLat];
		},
		getZoom() {
			const { spanLng, spanLat } = this.getCenterAndSpan();
			const correction = !this.$vuetify.breakpoint.smAndDown ? 1 : -0.5;
			// calculate the zoom by considering the maximum of the longitude span and latitude span as the boundary
			const zoomLng = Math.floor(Math.log2(360 / spanLng));
			const zoomLat = Math.floor(Math.log2(180 / spanLat));

			const zoom = Math.min(zoomLng, zoomLat);
			this.lastZoom = zoom === Infinity ? 16 : zoom === -Infinity ? 5.5 : zoom + correction;
			return this.lastZoom;
		},
		async onMapLoaded(event) {
			
			this.actions = event.component.actions;
			
			await this.actions.flyTo({
				center: this.getMiddlePoint(),
				zoom: this.getZoom(),
				speed: 4,
			});

			this.showPopUp = false;
		},
		moveMaker(event) {
			this.showPopUp = true;
			this.message = 'Pulse verificar cobertura';

			this.$emit('changeCoordinates', event.marker.getLngLat());
		},
	},
	computed: {
		markers(){
			return this.isArray() || this.customMarkers ? this.geoLatLng : [this.geoLatLng];
		},
	},
	watch: {
		geoLatLng: {
			handler() {
				const actualZoom = this.lastZoom;
				const nextZoom = this.getZoom();
				const zoomDiff = Math.abs(actualZoom - nextZoom)
				const speed = actualZoom && zoomDiff ? zoomDiff  * 0.5 : 4;
				this.actions.flyTo({
					center: this.getMiddlePoint(),
					zoom: this.getZoom(),
					speed: speed,
				});
			},
			deep: true,
			immidiate: true,
		}
	},
};
</script>

<style>
.mapbox-map {
	width: 100%;
	height: 600px;
}
.mapbox-map-fullscreen {
	width: 100%;
	height: 80vh;
}
.markerText {
	/* roboto-regular - latin */
	font-family: 'Roboto', sans-serif;
	position: relative;
	font-size: 20px;
	font-weight: 400;
}

@media screen and (max-width: 600px) {
	.markerText {
		font-size: 15px;
	}	
}
</style>